import { useMemo } from "react";
import { usePermissionAnyStatic } from "hooks/usePermission";

function useRequirePermission(Permission, type, permissionKeys) {
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));

  const isAccessible = useMemo(() => {
    // Fine-grained gating (preferred)
    if (permissionKeys && permissionKeys.length) {
      // If a type restriction is ALSO supplied, both must pass.
      if (type && !type.includes(loggedInUser?.type)) return false;
      return usePermissionAnyStatic(permissionKeys);
    }
    // Legacy coarse gating (until fully migrated)
    const typeOk = type ? type.includes(loggedInUser?.type) : true;
    const permOk = Permission
      ? Array.isArray(loggedInUser?.permissions) &&
        loggedInUser.permissions.some((userPermission) => Permission.includes(userPermission))
      : true;
    return typeOk && permOk;
  }, []);

  return isAccessible;
}

export default useRequirePermission;
